import { styled } from 'styled-components'

import {
  useDecodedToken,
  useCurrentUserInfo,
  useAuthIsFetchingUser,
} from 'core/auth/authStore'

const AppUserInfo = () => {
  const decodedToken = useDecodedToken()
  const currentUser = useCurrentUserInfo()
  const isFetchingUser = useAuthIsFetchingUser()

  const userId = decodedToken?.sub

  const displayName = currentUser?.username || currentUser?.firstName || userId

  return (
    <UserInfo>
      {isFetchingUser && !currentUser ? (
        'Loading…'
      ) : (
        <>
          <Label>User display name</Label>
          <div>{displayName || 'Unknown'}</div>
        </>
      )}
    </UserInfo>
  )
}

export default AppUserInfo

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: center;
  font-size: 12px;
`

const Label = styled.div`
  color: ${(props) => props.theme.labelText};
`
